// extracted by mini-css-extract-plugin
export default {"foundationType":"mastTab_foundationType__mkpSL"};